import React, { useEffect, useState } from "react";
import { WX } from "./TvBits";

const FALLBACK = "https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?w=1920&q=80";

export const TvLiving = ({ d }) => {
  const [now, setNow] = useState(new Date());
  useEffect(() => { const t = setInterval(() => setNow(new Date()), 15000); return () => clearInterval(t); }, []);
  const story = (d.world || []).find((w) => w.image) || (d.headlines || []).find((h) => h.image);
  const w = d.weather; const h = d.health;
  const rec = h?.recovery?.score ?? h?.recovery ?? null;
  return (
    <div className="relative h-full rounded-3xl overflow-hidden" data-testid="tv-scene-living">
      <img src={story?.image || FALLBACK} alt="" className="absolute inset-0 w-full h-full object-cover scale-105 nx-kenburns" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#030712]/90 via-[#030712]/50 to-[#030712]/20" />
      <div className="absolute top-8 right-10 text-right" data-testid="tv-living-clock">
        <p className="text-[clamp(1.25rem,2vw,2rem)] text-cyan-50/80 bg-[#030712]/70 rounded-xl px-4 py-1">{now.toLocaleDateString([], { weekday: "long", month: "long", day: "numeric" })}</p>
        {w && !w.error && <p className="text-[clamp(1.25rem,2vw,2rem)] text-cyan-100 mt-2 bg-[#030712]/70 rounded-xl px-4 py-1" data-testid="tv-living-weather">{Math.round(w.temp * 9 / 5 + 32)}°F · {WX[w.code] || ""} · {w.city}</p>}
      </div>
      {story && (
        <div className="absolute left-10 bottom-16 max-w-[60%]">
          <p className="nx-mono text-xl tracking-[0.3em] text-cyan-300/80 mb-3">TODAY'S STORY</p>
          <p className="text-[clamp(1.5rem,3vw,3.5rem)] font-black text-white leading-tight line-clamp-3">{story.title}</p>
        </div>
      )}
      {rec != null && <div className="absolute right-10 bottom-8 nx-glass rounded-2xl px-5 py-3 text-2xl text-emerald-300 font-bold" data-testid="tv-living-health">Recovery {Math.round(rec)}%</div>}
      <style>{`@keyframes nxKb { from { transform: scale(1.05) } to { transform: scale(1.15) translateX(-2%) } } .nx-kenburns { animation: nxKb 40s ease-in-out infinite alternate; }`}</style>
    </div>
  );
};
